export const POSSIBLE_SWIMLANES = [
  'recommended',
  'popular',
  'added',
  'recommendedSubject1',
  'recommendedSubject2',
  'recommendedSubject3',
];

const popularFilters = {
  recommendedSubject1: 'recommended.subject1',
  recommendedSubject2: 'recommended.subject2',
  recommendedSubject3: 'recommended.subject3',
};

export function getParams(id) {
  const params = {
    active: false,
    limit: 100,
    sort: id,
  };

  if (popularFilters[id]) {
    params.sort = 'popular';
    params.filters = [popularFilters[id]];
  }

  return params;
}
